import React, { useState } from "react";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,

} from "./HeroElements";
import Video from "./../../../videos/vid1-tunnel1080.mp4";
import Image1 from "./../../../images/logobackgroundBlank.png";
import "./../../../App.css";


const HeroSection = () => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay loop muted src={Video} type="video/mp4" />

      </HeroBg>
      <HeroContent>
        <h1 className="h1-hero">
          <span class="h1.text">Finding the </span>
          <span class="text-info">Possible </span>
          <span class="inthe">In Im</span>
          <span class="text-info">possible</span>
        </h1>


        <p className="hero-text"> Cyber Security Solutions and Services Built To Meet The Needs Of Your Business</p>

      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
